import FormField from "../FormInputs/FormField";
import SelectOrganization from "./SelectOrganization";
import { useState } from "react";
import {
  HOUSE_PAYOUT_RATIO_DENOMINATOR,
  HOUSE_PAYOUT_RATIO_NUMERATOR,
} from "../../utility/houseTournamentDefaults";

const TournamentInputs = ({
  tournamentDetails,
  setTournamentDetails,
  organizations,
  organizationalID,
  setOrganizationalID,
  errorMessages = {},
  hideOrganization = false,
}) => {
  const [payoutRatioError, setPayoutRatioError] = useState("");

  const validatePayoutRatio = (numerator, denominator) => {
    if (!numerator || !denominator) return "Payout ratio is required";
    if (numerator <= 0 || denominator <= 0) {
      return "Both numbers must be greater than 0";
    }
    return "";
  };

  const handlePayoutRatioBlur = () => {
    const error = validatePayoutRatio(
      tournamentDetails.payoutRatioNumerator,
      tournamentDetails.payoutRatioDenominator
    );
    setPayoutRatioError(error);
  };

  return (
    <>
      {!hideOrganization ? (
        <div>
          <SelectOrganization
            organizations={organizations}
            organizationalID={organizationalID}
            setOrganizationalID={setOrganizationalID}
          />
          {errorMessages.organization && (
            <p className="text-red-600 text-sm mt-1">
              {errorMessages.organization}
            </p>
          )}
        </div>
      ) : null}
      <FormField
        label="Tournament Name"
        type="text"
        value={tournamentDetails.name}
        onChange={(e) =>
          setTournamentDetails({
            ...tournamentDetails,
            name: e.target.value,
          })
        }
        error={errorMessages.name}
      />
      <FormField
        label="Start Date"
        type="date"
        value={tournamentDetails.startDate}
        onChange={(e) =>
          setTournamentDetails({
            ...tournamentDetails,
            startDate: e.target.value,
          })
        }
        error={errorMessages.startDate}
      />
      <div className="relative mb-4">
        <label className="absolute top-[-12px] left-3 bg-white px-1 text-brand-charcoal">
          Payout Ratio
        </label>
        <div className="flex items-center space-x-2 border border-brand-charcoal/20 rounded-lg p-3 focus-within:ring-2 focus-within:ring-brand-gold-ink">
          <input
            type="number"
            min="1"
            value={tournamentDetails.payoutRatioNumerator || ""}
            onChange={(e) =>
              setTournamentDetails({
                ...tournamentDetails,
                payoutRatioNumerator: e.target.value,
              })
            }
            onBlur={handlePayoutRatioBlur}
            className="w-20 border-none focus:outline-none bg-transparent font-score text-brand-charcoal"
            placeholder={String(HOUSE_PAYOUT_RATIO_NUMERATOR)}
          />
          <span className="text-brand-muted font-medium">in</span>
          <input
            type="number"
            min="1"
            value={tournamentDetails.payoutRatioDenominator || ""}
            onChange={(e) =>
              setTournamentDetails({
                ...tournamentDetails,
                payoutRatioDenominator: e.target.value,
              })
            }
            onBlur={handlePayoutRatioBlur}
            className="w-20 border-none focus:outline-none bg-transparent font-score text-brand-charcoal"
            placeholder={String(HOUSE_PAYOUT_RATIO_DENOMINATOR)}
          />
        </div>
        {payoutRatioError && (
          <p className="text-red-600 text-sm mt-1">{payoutRatioError}</p>
        )}
        {errorMessages.payoutRatio && (
          <p className="text-red-600 text-sm mt-1">
            {errorMessages.payoutRatio}
          </p>
        )}
      </div>
    </>
  );
};

export default TournamentInputs;
